import { COLORS } from '@musinsa/mds';
import { styled } from 'styled-components';

export const UIDivider = styled.div`
  width: calc(100% - 32px);
  height: 1px;
  background: ${COLORS.gray[500]};
  margin: 12px 0 12px 16px;
  opacity: 0.1;
`;
